import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createDiscardOutbound } from '../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { setPendingDiscardIndex } from '../../../redux/actions/pokerActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { CardDisplay } from './cardDisplay';
function getCardEmphasis(defaultHoleCardEmphasis, isIn, isMyDiscardTurn) {
    if (!isIn) {
        return 'dimmed';
    }
    if (isMyDiscardTurn) {
        return 'normal';
    }
    return defaultHoleCardEmphasis;
}
export const HoleCardDisplay = ({ cardIndex, isIn, cardRenderProperties, isMyDiscardTurn }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const numHoleCards = useAppSelector((state) => state.poker.holeCards?.length || 0);
    const holeCardRankChar = useAppSelector((state) => state.poker.holeCards?.[cardIndex]?.card.rankChar);
    const holeCardSuitChar = useAppSelector((state) => state.poker.holeCards?.[cardIndex]?.card.suitChar);
    const holeCardEmphasis = useAppSelector((state) => state.poker.holeCards?.[cardIndex]?.cardEmphasis);
    const isPendingDiscardCard = useAppSelector((state) => state.poker.pendingDiscardIndex === cardIndex);
    const holeCardPerformanceTimestampMs = useAppSelector((state) => state.poker.holeCards?.[cardIndex]?.performanceTimestampMs);
    const isFourColorDeckEnabled = useAppSelector((state) => state.selfData.isFourColorDeckEnabled);
    const onClickDiscard = useCallback(() => {
        dispatch(setPendingDiscardIndex(cardIndex));
        socketSend(createDiscardOutbound(cardIndex));
    }, [cardIndex, socketSend, dispatch]);
    if (!holeCardRankChar || !holeCardSuitChar || !holeCardEmphasis) {
        return null;
    }
    return (_jsx(CardDisplay, { pixiDataType: 'hole-card', cardRankChar: holeCardRankChar, cardSuitChar: holeCardSuitChar, cardIndex: cardIndex, cardEmphasis: getCardEmphasis(holeCardEmphasis, isIn, isMyDiscardTurn), cardRenderProperties: cardRenderProperties, numCardsInGroup: numHoleCards, onClick: isMyDiscardTurn ? onClickDiscard : undefined, startTimestampMs: holeCardPerformanceTimestampMs, animationType: 'show', isFourColorDeck: isFourColorDeckEnabled, isPendingDiscard: isPendingDiscardCard }));
};
